<template lang="pug">
  .layout-view
    .layout-view__controls
      v-btn(
        medium
        :disabled="isConsultant"
        @click="modals.showCreate = true")
        v-icon(
          position-left
          font-size="1"
          icon="plus").mr-1
        span {{ 'base.add_ingredient' | translate }}

    table.table

      //- TABLE HEADER
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell
            days-count-toggler(v-model="days")
          th.table__cell {{ 'base.rest_days' | translate }}
          th.table__cell {{ 'base.stock_rest' | translate }} [{{ 'base.kg' | translate }}]
          th.table__cell {{ 'base.price' | translate }} #[br] {{ 'base.currency' | translate }}
          th.table__cell
      
      //- TABLE BODY
      v-table-body(
        :cols="6"
        :loading="loading"
        :empty="!items.length"
        :label-empty="'info.stock_is_empty' | translate")
        tr.table__row(
          v-for="ingredient in items"
          :key="ingredient.id")
            td.table__cell {{ ingredient.name }}
            td.table__cell 
              span(:class="{ skeleton: wait }") {{ wait ? '' : Math.floor(ingredient.daily_feed_intake * days) }} 
              span {{ wait ? '' : 'base.kg' | translate }}
            td.table__cell {{ getRestOfDays(ingredient) }}
            td.table__cell {{ ingredient.total_amount | floor }}
            td.table__cell.nowrap
              | {{ ingredient.total_price | floor }} {{ 'base.currency' | translate }}
            td.table__cell.table__cell--thin
              v-btn.-mr-1(
                v-if="!isConsultant && !ingredient.is_default"
                icon
                @click="selected = ingredient")
                v-icon(
                  font-size="1.1"
                  icon="cog")

    //- TABLE PAGINATION
    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
    
    //- CREATE MODAL
    v-dialog(
      max-width="340"
      v-model="modals.showCreate")
      create-modal(
        @update="loadData"
        @close="modals.showCreate = false")
    
    //- EDIT MODAL
    v-dialog(
      max-width="340"
      :value="!!selected"
      @input="selected = null")
      edit-modal(
        :data="selected"
        @update="handleUpdate"
        @close="selected = null")
</template>

<script>
import api from '@/api'

import CreateModal from './CreateModal'
import EditModal from './EditModal'
import UiPagination from '@/components/ui/ui-pagination/UiPagination'
import DaysCountToggler from '../../farm/stock/ingredients/table/DaysCountToggler'

import paginationMixin from '@/mixins/pagination.mixin'

export default {
  name: 'Stock',

  mixins: [paginationMixin],

  components: {
    EditModal,
    CreateModal,
    DaysCountToggler,
    UiPagination
  },

  data: () => ({
    modals: {
      showCreate: false
    },
    days: 1,
    selected: null,
    wait: true
  }),

  mounted () {
    this.setupPagination(
      api.ingredients.list,
      {
        stock: this.$route.params.stock_id,
        is_animalfeed: false
      },
      `stock_ingredients_${this.$route.params.stock_id}`
    )
    this.loadDailyFeedIntakes()
  },

  methods: {
    handleUpdate (stock) {
      this.$emit('update', stock)
    },
    getRestOfDays (item) {
      if (item.daily_feed_intake > 0) {
        return Math.floor(item.total_amount / item.daily_feed_intake)
      }
      return '-'
    },
    async loadDailyFeedIntakes () {
      this.wait = true
      const { query } = this.$route
      try {
        const { data } = await api.ingredients.dailyFeedIntakes({
          // farm: this.$route.params.farm_id,
          is_animalfeed: false,
          stock: query.stock ? query.stock : '-1',
          page: this.page,
          offset: (this.page - 1) * 100 || null,

        })
        this.items.forEach(item => {
          const updatedItem = data.find(d => d.id === item.id)
          if (updatedItem) {
            item.daily_feed_intake = updatedItem.daily_feed_intake
          }
        })
        this.wait = false
        this.$forceUpdate()
      } catch (error) {
        console.error('Error loading ingredients:', error)
        this.wait = false
      }
    }
  },
  watch: {
    page () {
      this.loadDailyFeedIntakes()
    }
  }
}
</script>
<style scoped>
span.skeleton {width: 20px; display: inline-block;height: 20px; background: red;}
</style>